export var PLATFORM;
(function (PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
})(PLATFORM || (PLATFORM = {}));
export var MODE;
(function (MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
})(MODE || (MODE = {}));
//# sourceMappingURL=events.js.map